import LinkToDocusaurus from '../LinkToDocusaurus'
import { Paragraph } from '@eggplant/pattern-library'

// TODO: ETD-7990 add docusaurus links
const DuplicateGitDescription = () =>
  <Paragraph>
    <strong>
      Select a space to duplicate your asset to. Associated assets will be included in the duplication.
    </strong>
    <LinkToDocusaurus path=''>Learn more in the DAI documentation</LinkToDocusaurus>
  </Paragraph>

export default DuplicateGitDescription
